<mat-card appearance="outlined" class="review-card" *ngIf="review$ | async as review">
  <mat-card-header>
    <span mat-card-avatar [ngClass]="(review | checkReviewDeleted) ? 'deleted' : ''">
      <va-icon
        [diameter]="40"
        [iconUrl]="'//www.cdnstyles.com/static/images/icon50/sourceId-' + review.sourceID + '.png'"
      ></va-icon>
    </span>
    <mat-card-title [ngClass]="(review | checkReviewDeleted) ? 'deleted' : ''">
      <div class="review-card-header-content">
        <div class="review-card-header-content-title">
          <a
            *ngIf="review.reviewerUrl"
            target="_blank"
            [href]="review.reviewerUrl"
            class="reviewer-name"
            data-action="view-reviewer-profile"
          >
            {{ review.reviewerName }}
          </a>
          <span *ngIf="!review.reviewerUrl" class="reviewer-name">
            {{ review.reviewerName }}
          </span>
          <reviews-recommended-icon
            *ngIf="isPositiveRecommendation"
            class="recommendation-icon"
          ></reviews-recommended-icon>
          <reviews-not-recommended-icon
            *ngIf="isNegativeRecommendation"
            class="recommendation-icon"
          ></reviews-not-recommended-icon>
          <ng-container *ngIf="isRecommendation">
            {{
              (isPositiveRecommendation
                ? 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RECOMMENDATION_TITLE'
                : 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.NOT_RECOMMENDATION_TITLE'
              ) | translate
            }}
            <a *ngIf="review.businessName" target="_blank" [href]="review.respondUrl" data-action="view-review">
              {{ review.businessName }}
            </a>
            <ng-container *ngIf="!review.businessName">
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.YOUR_BUSINESS' | translate }}
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!isRecommendation">
            <span class="review-action">
              {{
                'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.TITLE'
                  | translate
                    : {
                        review_domain:
                          (review.sourceID === sourceIds.MY_LISTING
                            ? 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.MY_LISTING_SOURCE_NAME'
                            : review.domain
                          ) | translate,
                        reviewer_name: '',
                      }
              }}
            </span>
          </ng-container>
        </div>
        <ng-container *ngIf="!!businessReviewsURL">
          <div class="product-url">
            <a [href]="businessReviewsURL" target="_blank">
              {{ reviewConfig.company.name }}
            </a>
            <span class="business-address">
              • {{ reviewConfig.company.address }},
              {{ reviewConfig.company.city }}
            </span>
          </div>
        </ng-container>
      </div>
    </mat-card-title>
    <mat-card-subtitle [ngClass]="(review | checkReviewDeleted) ? 'deleted' : ''">
      {{ fromNow(review.published) }}
      <i *ngIf="editedFromNow">
        <a [class.no-click]="!reviewHistoryEnabled" (click)="openReviewHistoryCardModal()">
          ({{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.SUBTITLE.EDITED' | translate }} {{ editedFromNow }})
        </a>
      </i>
    </mat-card-subtitle>

    <div class="card-tertiary-actions">
      <a
        *ngIf="
          (isSharingReviewEnabled || isPublishingReviewEnabled) &&
          (!(review | checkReviewDeleted) || isPublishedMyListingReview || isPublishedThirdPartyReview)
        "
        [matMenuTriggerFor]="shareMenu"
        class="tertiary-action-icon"
        data-action="share-review"
      >
        <mat-icon>share</mat-icon>
      </a>
      <mat-menu #shareMenu="matMenu">
        <a
          *ngIf="isSharingReviewEnabled && !(review | checkReviewDeleted)"
          mat-menu-item
          [href]="review.shareUrl"
          data-action="share-review"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.SHARE_ON_SOCIAL' | translate }}
        </a>
        <a
          mat-menu-item
          (click)="unpublish()"
          *ngIf="review.isPublished && review.sourceID === sourceIds.MY_LISTING"
          data-action="unpublish-review"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.UNPUBLISH_FROM_MY_LISTING' | translate }}
        </a>
        <a
          mat-menu-item
          (click)="publish()"
          *ngIf="!review.isPublished && review.sourceID === sourceIds.MY_LISTING && !(review | checkReviewDeleted)"
          data-action="publish-review"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.PUBLISH_TO_MY_LISTING' | translate }}
        </a>
        <a
          mat-menu-item
          (click)="unpublishFromReviewWidget()"
          *ngIf="shouldDisplayReviewWidgetMenu && isPublishedThirdPartyReview"
          data-action="unpublish-review"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.UNPUBLISH_FROM_REVIEW_WIDGET' | translate }}
        </a>
        <a
          mat-menu-item
          (click)="publishToReviewWidget()"
          *ngIf="shouldDisplayReviewWidgetMenu && !isPublishedThirdPartyReview && !(review | checkReviewDeleted)"
          data-action="publish-review"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.PUBLISH_TO_REVIEW_WIDGET' | translate }}
        </a>
      </mat-menu>
      <a
        href="{{ review.url }}"
        target="_blank"
        [matTooltip]="'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.VIEW' | translate"
        class="tertiary-action-icon"
        data-action="view-review"
      >
        <mat-icon>open_in_new</mat-icon>
      </a>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div [ngClass]="(review | checkReviewDeleted) ? 'deleted' : ''">
      <div *ngIf="!isRecommendation" class="stars">
        <mat-icon [ngClass]="star ? 'star-lit' : 'star'" *ngFor="let star of reviewStars">star</mat-icon>
      </div>
      <div *ngIf="review.title && (!review.content || !review.content.startsWith(review.title))" class="review-title">
        {{ review.title }}
      </div>
      <div
        *ngIf="review.content"
        [innerHTML]="
          review.content | transformReviewContent: { hideEnglishTranslations: hideGoogleTranslatedReviewContent }
        "
      ></div>
      <div class="badges">
        <span *ngIf="review.edited" class="badge badge--gray">
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.EDITED' | translate }}
        </span>
        <mat-menu #statusMenu="matMenu">
          <a
            mat-menu-item
            (click)="updateStatus(ReviewStatus.ACTION_REQUIRED)"
            data-action="update-review-status-action-required"
          >
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.ACTION_REQUIRED' | translate }}
          </a>
          <a
            mat-menu-item
            (click)="updateStatus(ReviewStatus.OWNER_RESPONDED)"
            data-action="update-review-status-owner-responded"
          >
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.RESPONDED' | translate }}
          </a>
          <a
            mat-menu-item
            (click)="updateStatus(ReviewStatus.NO_ACTION_REQUIRED)"
            data-action="update-review-status-no-action-required"
          >
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.NO_ACTION_REQUIRED' | translate }}
          </a>
        </mat-menu>
        <span
          *ngIf="review.status === ReviewStatus.ACTION_REQUIRED"
          class="badge badge-menu badge--red"
          [matMenuTriggerFor]="statusMenu"
          [ngClass]="{ 'menu-disabled': (review | checkReviewDeleted) }"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.ACTION_REQUIRED' | translate }}
          <mat-icon>arrow_drop_down</mat-icon>
        </span>
        <span
          *ngIf="review.status === ReviewStatus.NO_ACTION_REQUIRED"
          class="badge badge-menu"
          [matMenuTriggerFor]="statusMenu"
          [ngClass]="{ 'menu-disabled': (review | checkReviewDeleted) }"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.NO_ACTION_REQUIRED' | translate }}
          <mat-icon>arrow_drop_down</mat-icon>
        </span>
        <span
          *ngIf="
            review.status === ReviewStatus.OWNER_RESPONDED || review.status === ReviewStatus.DIGITAL_AGENT_RESPONDED
          "
          class="badge badge-menu badge--green"
          [matMenuTriggerFor]="statusMenu"
          [ngClass]="{ 'menu-disabled': (review | checkReviewDeleted) }"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.RESPONDED' | translate }}
          <mat-icon>arrow_drop_down</mat-icon>
        </span>
        <span *ngIf="isPublishedMyListingReview || isPublishedThirdPartyReview" class="badge badge--blue">
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.PUBLISHED' | translate }}
        </span>

        <ng-container *ngIf="!digitalAgentView && showFulfillmentRespondedBadge">
          <span *ngIf="review.status === ReviewStatus.DIGITAL_AGENT_RESPONDED" class="badge badge--green">
            <ng-container *ngTemplateOutlet="fulfillmentRespondedInfo"></ng-container>
          </span>
        </ng-container>

        <ng-container *ngIf="digitalAgentView">
          <span
            *ngIf="digitalAgentTaskFlags.includes(VTMReviewFlags.RESPONSE_AWAITING_APPROVAL)"
            class="badge badge--blue"
          >
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.AWAITING_APPROVAL' | translate }}
          </span>
          <span *ngIf="digitalAgentTaskFlags.includes(VTMReviewFlags.FEEDBACK_PROVIDED)" class="badge badge--yellow">
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.FEEDBACK_PROVIDED' | translate }}
          </span>
          <span *ngIf="digitalAgentTaskFlags.includes(VTMReviewFlags.RESPONSE_APPROVED)" class="badge badge--green">
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.RESPONSE_APPROVED' | translate }}
          </span>
          <span *ngIf="hasOwnerResponded && !hasDigitalAgentResponded" class="badge badge--yellow">
            {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.OWNER_RESPONDED' | translate }}
          </span>
          <span *ngIf="review.status === ReviewStatus.DIGITAL_AGENT_RESPONDED" class="badge badge--green">
            <ng-container *ngTemplateOutlet="fulfillmentRespondedInfo"></ng-container>
          </span>
        </ng-container>

        <ng-template #fulfillmentRespondedInfo>
          <ng-container *ngIf="reviewConfig.partnerName; else fulfillmentResponded">
            <span>
              {{
                'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.PARTNER_RESPONDED'
                  | translate: { partnerName: reviewConfig.partnerName }
              }}
            </span>
          </ng-container>
          <ng-template #fulfillmentResponded>
            <span>
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.CHIP_LABELS.FULFILLMENT_RESPONDED' | translate }}
            </span>
          </ng-template>
        </ng-template>
      </div>

      <div class="not-connected-banner" *ngIf="digitalAgentView && showConnectBanner()">
        <mat-icon color="orange" class="inline-icon-padding">warning</mat-icon>
        {{
          'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONNECT_ACCOUNTS.NOT_CONNECTED'
            | translate
              : {
                  source: review.sourceID === sourceIds.GOOGLE_MAPS ? 'Google Business Profile' : 'Facebook',
                }
        }}
        <a href="{{ businessSettingsURL }}" class="repman-settings-link">
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONNECT_ACCOUNTS.GO_TO_RM_TO_CONNECT' | translate }}
        </a>
      </div>

      <div class="comments" *ngIf="review.comments.length > 0">
        <div class="comment-count" (click)="showComments = !showComments" *ngIf="review.comments.length > 1">
          {{
            (showComments
              ? 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.HIDE'
              : 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.VIEW'
            ) | translate
          }}
          {{ review.comments.length - (isLastFailedReviewComment ? 0 : 1) }}
          {{
            (review.comments.length > 2
              ? 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.COMMENTS'
              : 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.ACTIONS.COMMENT'
            ) | translate
          }}
        </div>
        <div class="comment-feed">
          <ng-container *ngFor="let c of review.comments; last as isLast">
            <div class="comment" *ngIf="showComments || (isLast && !isLastFailedReviewComment)">
              <div
                class="comment-content"
                [ngClass]="{
                  collapsed: (commentEditorVisibleMap$ | async)[c.commentId],
                }"
              >
                <div class="comment-text">
                  <div>
                    <span class="comment-by">
                      {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.MESSAGES.RESPONSE_FROM' | translate }}
                      {{ c.commentAuthor ? c.commentAuthor : reviewConfig.company.name }}
                    </span>
                    <span
                      [innerHtml]="
                        c.commentText
                          | transformReviewContent: { hideEnglishTranslations: hideGoogleTranslatedReviewContent }
                      "
                    ></span>
                  </div>
                  <ng-container *ngIf="isCommentEditable && c.postedByOwner">
                    <button
                      mat-icon-button
                      data-action="edit-clicked"
                      class="edit-button"
                      color="primary"
                      (click)="showCommentEditor(c.commentId)"
                      [disabled]="review | checkReviewDeleted"
                    >
                      <mat-icon class="edit-button-icon">edit</mat-icon>
                    </button>
                  </ng-container>
                </div>
                <div class="comment-meta">{{ c | commentFromNow }}</div>
              </div>
              <div
                class="comment-editor"
                *ngIf="c.postedByOwner"
                [ngClass]="{
                  collapsed: !(commentEditorVisibleMap$ | async)[c.commentId],
                }"
              >
                <glxy-form-field>
                  <textarea
                    #editCommentInput
                    matInput
                    cdkTextareaAutosize
                    [placeholder]="'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.EDIT' | translate"
                    [value]="
                      c.commentText
                        | transformReviewContent: { hideEnglishTranslations: hideGoogleTranslatedReviewContent }
                    "
                  ></textarea>
                </glxy-form-field>
                <div class="response-actions">
                  <button
                    color="primary"
                    (click)="
                      editCommentInput.value = removeGoogleTranslation(c.commentText); hideCommentEditor(c.commentId)
                    "
                    mat-button
                    data-action="cancel-edit-review-comment"
                    [disabled]="review | checkReviewDeleted"
                  >
                    {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CANCEL' | translate }}
                  </button>
                  <button
                    (click)="editComment(c, editCommentInput.value, review.sourceID)"
                    color="primary"
                    mat-raised-button
                    data-action="edit-review-comment"
                    [disabled]="review | checkReviewDeleted"
                  >
                    {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.SAVE' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="!digitalAgentView">
        <div
          class="task-manager-response"
          [ngClass]="{ collapsed: !showTaskManagerComment }"
          *ngIf="taskManagerResponse$ | async as res"
        >
          <div class="task-manager-response-content">
            <div class="task-manager-response--title">
              <va-icon [diameter]="20" [iconUrl]="res.favicon_url"></va-icon>
              <b>
                {{
                  'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.TITLE'
                    | translate
                      : {
                          agentName: res.agent_name,
                          partnerName: res.partner_name,
                        }
                }}
              </b>
            </div>
            <div class="task-manager-response--text">
              {{ res.response }}
            </div>
            <div *ngIf="res.feedback" class="task-manager-response--feedback">
              <div class="feedback-content">
                <mat-icon color="accent">check_circle</mat-icon>
                <b>
                  {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.FEEDBACK' | translate }}
                </b>
              </div>
              {{ res.feedback }}
            </div>
            <div *ngIf="res.tags.indexOf('Approved') > -1" class="task-manager-response--feedback">
              <div class="feedback-content">
                <mat-icon color="accent">check_circle</mat-icon>
                <b>
                  {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.FEEDBACK' | translate }}
                </b>
              </div>
              {{
                'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.APPROVED_FEEDBACK'
                  | translate: { partnerName: res.partner_name }
              }}
            </div>
          </div>
        </div>
      </ng-container>

      <div
        class="last-failed-review-comment"
        *ngIf="
          isLastFailedReviewComment &&
          ((taskManagerResponse$ | async) === null || (taskManagerResponse$ | async) === undefined)
        "
      >
        <div class="last-failed-review-content">
          <mat-icon class="last-failed-review-comment-error-icon">error</mat-icon>
          <div class="flex-column">
            <span *ngIf="this.lastFailedReviewCommentReason" class="last-failed-review-comment-error">
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.MESSAGES.REVIEW_HAS_BEEN_DELETED' | translate }}
            </span>
            <span *ngIf="!this.lastFailedReviewCommentReason" class="last-failed-review-comment-error">
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.MESSAGES.LAST_FAILED_REVIEW_COMMENT' | translate }}
            </span>
            <span class="last-failed-review-comment-meta">
              {{ fromNow(review.lastFailedReviewCommentCreated) }}
            </span>
          </div>
        </div>
      </div>

      <div
        class="responder"
        [ngClass]="{
          collapsed:
            !enableResponse ||
            !showlastFailedReviewCommentResponseBox ||
            !isLastFailedReviewComment ||
            (taskManagerResponse$ | async) ||
            (review | checkReviewDeleted),
        }"
        #lastFailedReviewCommentResponder
      >
        <div class="response-box">
          <div class="response-area">
            <textarea
              #lastFailedReviewCommentResponseBox
              matInput
              cdkTextareaAutosize
              class="response-input"
              #autoSize="cdkTextareaAutosize"
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="20"
              (input)="handleInputChange(lastFailedReviewCommentResponseBox.value)"
              [placeholder]="responseBoxText$ | async"
              [value]="review.lastFailedReviewCommentText"
            ></textarea>
          </div>
          <div class="response-box-bottom-row">
            <ng-container *ngIf="responseTemplates | filterTemplates: review.rating : taxonomyIds as filteredTemplates">
              <div
                class="response-templates"
                *ngIf="filteredTemplates.length > 0 && (language === 'en' || nonEnglishReviewResponseTemplates)"
              >
                <div class="response-chips">
                  <button
                    *ngIf="openAIEnabled"
                    mat-stroked-button
                    class="response-chip"
                    color="primary"
                    (click)="suggestReviewResponse(responseBox, review)"
                    data-action="suggest-review-response-clicked"
                  >
                    <glxy-button-loading-indicator [isLoading]="suggestingResponse$ | async">
                      <mat-icon svgIcon="galaxy-ai-icon" class="ai-icon" />
                      {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.SUGGEST_RESPONSE' | translate }}
                    </glxy-button-loading-indicator>
                  </button>
                  <button
                    mat-stroked-button
                    class="response-chip"
                    color="primary"
                    *ngFor="
                      let template of filteredTemplates
                        | randomizeTemplates
                        | paginateTemplates: reviewResponseTemplatePage
                    "
                    (click)="renderResponseTemplate(responseBox, template, reviewConfig, review)"
                    data-action="response-template-clicked"
                  >
                    {{ template.title }}
                  </button>
                </div>
                <button
                  *ngIf="filteredTemplates.length > 3"
                  mat-icon-button
                  color="primary"
                  class="shuffle-templates"
                  data-action="shuffle-templates-clicked"
                  (click)="reviewResponseTemplatePage = reviewResponseTemplatePage + 1"
                >
                  <mat-icon>shuffle</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
        <mat-error
          *ngIf="language === 'en' && (lastFailedReviewCommentResponseBox.value | validateResponse).placeholderWarning"
          class="response-warning"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.PLACEHOLDER_WARNING' | translate }}
        </mat-error>
        <mat-error
          *ngIf="language === 'en' && (lastFailedReviewCommentResponseBox.value | validateResponse).googleUserWarning"
          class="response-warning"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.GOOGLE_USER_WARNING' | translate }}
        </mat-error>
        <mat-hint
          class="response-hint"
          *ngIf="review.sourceID === sourceIds.MY_LISTING"
          [innerHTML]="'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.HINT' | translate"
        ></mat-hint>
      </div>

      <div
        class="responder"
        [ngClass]="{
          collapsed: !showTaskManagerRespondBox || (review | checkReviewDeleted),
        }"
        #feedbackResponder
      >
        <div class="response-box">
          <div class="response-area">
            <textarea
              #feedbackBox
              matInput
              cdkTextareaAutosize
              class="response-input"
              #autoSize="cdkTextareaAutosize"
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="20"
            ></textarea>
          </div>
        </div>
      </div>

      <div
        class="responder"
        [ngClass]="{
          collapsed:
            !digitalAgentView &&
            ((!showRespondBox && !showRespondBoxWithSuggestedText) ||
              (taskManagerResponse$ | async) ||
              isLastFailedReviewComment ||
              (review | checkReviewDeleted)),
        }"
        #responder
      >
        <div class="response-box">
          <div class="response-area">
            <textarea
              #responseBox
              matInput
              cdkTextareaAutosize
              class="response-input"
              #autoSize="cdkTextareaAutosize"
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="20"
              (input)="handleInputChange(responseBox.value)"
              [value]="(taskManagerResponse$ | async)?.response || ''"
              (blur)="handleBlur(responseBox.value)"
              (focus)="handleFocus(responseBox.value)"
              [placeholder]="responseBoxText$ | async"
            ></textarea>
          </div>
          <div class="response-box-bottom-row">
            <ng-container *ngIf="responseTemplates | filterTemplates: review.rating : taxonomyIds as filteredTemplates">
              <div
                class="response-templates"
                *ngIf="filteredTemplates.length > 0 && (language === 'en' || nonEnglishReviewResponseTemplates)"
              >
                <div class="response-chips">
                  <button
                    *ngIf="openAIEnabled"
                    mat-stroked-button
                    class="response-chip"
                    color="primary"
                    (click)="suggestReviewResponse(responseBox, review)"
                    data-action="suggest-review-response-clicked"
                  >
                    <glxy-button-loading-indicator [isLoading]="suggestingResponse$ | async">
                      <mat-icon svgIcon="galaxy-ai-icon" class="ai-icon" />
                      {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.SUGGEST_RESPONSE' | translate }}
                    </glxy-button-loading-indicator>
                  </button>
                  <button
                    mat-stroked-button
                    class="response-chip"
                    color="primary"
                    *ngFor="
                      let template of filteredTemplates
                        | randomizeTemplates
                        | paginateTemplates: reviewResponseTemplatePage
                    "
                    (click)="renderResponseTemplate(responseBox, template, reviewConfig, review)"
                    data-action="response-template-clicked"
                  >
                    {{ template.title }}
                  </button>
                </div>
                <button
                  *ngIf="filteredTemplates.length > 3"
                  mat-icon-button
                  color="primary"
                  class="shuffle-templates"
                  data-action="shuffle-templates-clicked"
                  (click)="reviewResponseTemplatePage = reviewResponseTemplatePage + 1"
                >
                  <mat-icon>shuffle</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
        <mat-error
          *ngIf="language === 'en' && (responseBox.value | validateResponse).placeholderWarning"
          class="response-warning"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.PLACEHOLDER_WARNING' | translate }}
        </mat-error>
        <mat-error
          *ngIf="language === 'en' && (responseBox.value | validateResponse).googleUserWarning"
          class="response-warning"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.GOOGLE_USER_WARNING' | translate }}
        </mat-error>
        <mat-hint
          class="response-hint"
          *ngIf="review.sourceID === sourceIds.MY_LISTING"
          [innerHTML]="'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.HINT' | translate"
        ></mat-hint>
      </div>
    </div>

    <div class="deleted-info" *ngIf="review | checkReviewDeleted">
      <div class="deleted-info-text">
        {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.DELETED.INFO' | translate: { source_name: review.domain } }}
      </div>
      <span [@showHelperText]="isHelperTextVisible">
        <mat-divider class="deleted-info-mat-divider"></mat-divider>
      </span>
      <div class="flex-column">
        <div
          class="deleted-info-text"
          [@showHelperText]="isHelperTextVisible"
          [innerHTML]="
            'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.DELETED.NOTE' | translate: { source_name: review.domain }
          "
        ></div>
        <div class="deleted-info-buttons">
          <button
            [ngClass]="{
              'expanded-colour': isHelperTextVisible,
              'collapsed-colour': !isHelperTextVisible,
            }"
            mat-icon-button
            (click)="toggleShowHelperText()"
            matTooltip="{{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.DELETED.INFO_TOOLTIP' | translate }}"
          >
            <mat-icon>help_outline</mat-icon>
          </button>
          <div class="deleted-info-button-mobile">
            <button
              color="primary"
              mat-stroked-button
              *ngIf="review | checkReviewDeleted: reviewDeletedStatus.REVIEW_DELETED_STATUS_UNSPECIFIED"
              (click)="updateDeletedStatus(reviewDeletedStatus.REVIEW_DELETED_STATUS_USER_REMOVED)"
            >
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.DELETED.CONFIRM_DELETED' | translate }}
            </button>
            <button
              color="primary"
              mat-stroked-button
              (click)="updateDeletedStatus(reviewDeletedStatus.REVIEW_DELETED_STATUS_USER_KEPT)"
            >
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.DELETED.CONFIRM_NOT_DELETED' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="footer" [ngClass]="(review | checkReviewDeleted) ? 'deleted' : ''">
      <ng-container *ngIf="!digitalAgentView">
        <div *ngIf="taskManagerResponse$ | async as res">
          <div
            *ngIf="!res.feedback && res.tags.indexOf('Approved') === -1 && !provideTaskManagerFeedback"
            class="concierge-response--button"
          >
            <button
              color="primary"
              (click)="provideFeedback()"
              data-action="provide-concierge-feedback"
              mat-button
              [disabled]="review | checkReviewDeleted"
            >
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.PROVIDE_FEEDBACK_BUTTON' | translate }}
            </button>
            <button
              color="primary"
              (click)="approveResponse()"
              data-action="approve-concierge-response"
              mat-raised-button
              [disabled]="review | checkReviewDeleted"
            >
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.APPROVE_BUTTON' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
      <!-- Controls showing connect account dialog or sending user to appropriate source to view review when responding in product is not available-->
      <ng-container
        *ngIf="
          !digitalAgentView &&
          showRespondButton &&
          !((taskManagerResponse$ | async) || (showRespondBox && !provideTaskManagerFeedback)) &&
          !isLastFailedReviewComment
        "
      >
        <div
          class="connect-info flex-column"
          *ngIf="
            !canShowResponseBox() &&
            !suggestResponseOnAllSources &&
            (review.sourceID === sourceIds.GOOGLE_MAPS || review.sourceID === sourceIds.FACEBOOK)
          "
        >
          <div class="connect-info-content">
            <mat-icon class="connect-info-icon">info_outline</mat-icon>
            <div class="connect-info-text">
              {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.RESPONSE_BOX.CONNECT_ACCOUNT' | translate }}
            </div>
          </div>
          <div class="flex-column">
            <div class="connect-info-button">
              <button
                (click)="respondButtonPressed()"
                color="primary"
                mat-stroked-button
                data-action="connect-to-source"
                [disabled]="review | checkReviewDeleted"
              >
                <div *ngIf="review.sourceID === sourceIds.GOOGLE_MAPS && !canShowResponseBox()">
                  {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CONNECT' | translate: { source: 'Google' } }}
                </div>
                <div *ngIf="review.sourceID === sourceIds.FACEBOOK && !canShowResponseBox()">
                  {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CONNECT' | translate: { source: 'Facebook' } }}
                </div>
              </button>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            (review.sourceID !== sourceIds.GOOGLE_MAPS && review.sourceID !== sourceIds.FACEBOOK) ||
            canShowResponseBox()
          "
        >
          <ng-container *ngIf="showRespondBoxWithSuggestedText; else defaultRespondButton">
            <button
              class="suggest-response-copy-button"
              color="primary"
              [cdkCopyToClipboard]="responseBox.value"
              (cdkCopyToClipboardCopied)="responseBoxTextCopied($event)"
              mat-stroked-button
              data-action="copy-suggested-response-to-clipboard-clicked"
              [disabled]="!responseBox.value || (review | checkReviewDeleted)"
            >
              <mat-icon class="copy-to-clip-board-icon">content_copy</mat-icon>
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.COPY_RESPONSE' | translate }}
            </button>
            <button
              (click)="respondButtonPressed()"
              color="primary"
              mat-raised-button
              data-action="respond-to-review-on-source"
              [disabled]="review | checkReviewDeleted"
            >
              {{
                'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.RESPOND_ON_SOURCE'
                  | translate
                    : {
                        review_domain:
                          (review.sourceID === sourceIds.MY_LISTING
                            ? 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.MY_LISTING_SOURCE_NAME'
                            : review.domain
                          ) | translate,
                      }
              }}
              <mat-icon>open_in_new</mat-icon>
            </button>
          </ng-container>
          <ng-template #defaultRespondButton>
            <button
              (click)="respondButtonPressed()"
              color="primary"
              mat-raised-button
              data-action="respond-to-review"
              [disabled]="review | checkReviewDeleted"
            >
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.RESPOND' | translate }}
            </button>
          </ng-template>
        </div>
        <div
          *ngIf="
            (review.sourceID === sourceIds.GOOGLE_MAPS || review.sourceID === sourceIds.FACEBOOK) &&
            showRespondBoxWithSuggestedText
          "
        >
          <button
            class="suggest-response-connect-button"
            (click)="connectButtonPressed()"
            color="primary"
            mat-stroked-button
            data-action="connect-to-source"
            [disabled]="review | checkReviewDeleted"
          >
            <div *ngIf="review.sourceID === sourceIds.GOOGLE_MAPS && !canShowResponseBox()">
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CONNECT' | translate: { source: 'Google' } }}
            </div>
            <div *ngIf="review.sourceID === sourceIds.FACEBOOK && !canShowResponseBox()">
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CONNECT' | translate: { source: 'Facebook' } }}
            </div>
          </button>
          <button
            class="suggest-response-copy-button"
            color="primary"
            [cdkCopyToClipboard]="responseBox.value"
            (cdkCopyToClipboardCopied)="responseBoxTextCopied($event)"
            mat-stroked-button
            data-action="copy-suggested-response-to-clipboard-clicked"
            [disabled]="!responseBox.value || (review | checkReviewDeleted)"
          >
            <mat-icon class="copy-to-clip-board-icon">content_copy</mat-icon>
            {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.COPY_RESPONSE' | translate }}
          </button>
          <button
            (click)="respondOnSourceButtonPressed()"
            color="primary"
            mat-raised-button
            data-action="respond-to-review-on-source"
            [disabled]="review | checkReviewDeleted"
          >
            {{
              'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.RESPOND_ON_SOURCE'
                | translate
                  : {
                      review_domain:
                        (review.sourceID === sourceIds.MY_LISTING
                          ? 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.REVIEW_CARD.MY_LISTING_SOURCE_NAME'
                          : review.domain
                        ) | translate,
                    }
            }}
            <mat-icon>open_in_new</mat-icon>
          </button>
        </div>
      </ng-container>
      <div
        class="response-actions"
        *ngIf="enableResponse && !showlastFailedReviewCommentResponseBox && isLastFailedReviewComment"
      >
        <button
          (click)="showLastFailedReviewCommentEditor()"
          color="primary"
          mat-raised-button
          data-action="retry-last-failed-review-comment"
          [disabled]="review | checkReviewDeleted"
        >
          {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.RETRY' | translate }}
        </button>
      </div>

      <!-- feedback buttons -->
      <div *ngIf="provideTaskManagerFeedback && showTaskManagerRespondBox">
        <button
          color="primary"
          (click)="cancelFeedback()"
          mat-button
          data-action="cancel-concierge-feedback"
          [disabled]="review | checkReviewDeleted"
        >
          {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CANCEL' | translate }}
        </button>
        <button
          color="primary"
          (click)="saveFeedback(feedbackBox.value)"
          data-action="save-concierge-feedback"
          mat-raised-button
          [disabled]="review | checkReviewDeleted"
        >
          {{ 'COMMON_REVIEW_CARD.REVIEWS.MANAGE.CONCIERGE_RESPONSE.SEND_FEEDBACK_BUTTON' | translate }}
        </button>
      </div>

      <!-- These buttons are used for actually posted -->
      <div *ngIf="!digitalAgentView; else digitalAgentButtons" class="action-buttons">
        <div
          class="action-buttons-container"
          *ngIf="
            showRespondBox &&
            ((taskManagerResponse$ | async) === null || (taskManagerResponse$ | async) === undefined) &&
            !isLastFailedReviewComment
          "
        >
          <button
            color="primary"
            (click)="responseBox.value = null; cancelButtonPressed()"
            mat-button
            data-action="cancel-review-comment"
            [disabled]="review | checkReviewDeleted"
          >
            {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CANCEL' | translate }}
          </button>
          <ng-container *ngIf="(isPublishLoading$$ | async) === false; else responding">
            <button
              mat-raised-button
              data-action="post-review-comment"
              (click)="saveComment(responseBox.value)"
              color="primary"
              [disabled]="
                !responseBox.value ||
                (responseBox.value | validateResponse).googleUserWarning ||
                (review | checkReviewDeleted)
              "
            >
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.RESPOND' | translate }}
            </button>
          </ng-container>
        </div>
        <div
          class="action-buttons-container"
          *ngIf="
            enableResponse &&
            showlastFailedReviewCommentResponseBox &&
            ((taskManagerResponse$ | async) === null || (taskManagerResponse$ | async) === undefined) &&
            isLastFailedReviewComment
          "
        >
          <button
            color="primary"
            (click)="hideLastFailedReviewCommentEditor()"
            mat-button
            data-action="cancel-edit-last-failed-review-comment"
            [disabled]="review | checkReviewDeleted"
          >
            {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.CANCEL' | translate }}
          </button>
          <ng-container *ngIf="(isPublishLoading$$ | async) === false; else responding">
            <button
              (click)="saveComment(lastFailedReviewCommentResponseBox.value)"
              color="primary"
              [disabled]="
                !lastFailedReviewCommentResponseBox.value ||
                (lastFailedReviewCommentResponseBox.value | validateResponse).googleUserWarning ||
                (review | checkReviewDeleted)
              "
              mat-raised-button
              data-action="post-last-failed-review-comment"
            >
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.RETRY' | translate }}
            </button>
          </ng-container>
        </div>
        <a color="primary" *ngIf="isDebug$ | async" mat-button href="{{ reviewDataLink }}" target="_blank">
          {{ review.reviewID }}
        </a>
      </div>

      <ng-template #digitalAgentButtons>
        <div class="digital-agent-buttons">
          <div class="digital-agent-button-container" *ngIf="(canPublishDirect$ | async) !== true">
            <button
              class="suggest-response-copy-button"
              color="primary"
              [cdkCopyToClipboard]="responseBox.value"
              (cdkCopyToClipboardCopied)="responseBoxTextCopied($event)"
              mat-stroked-button
              data-action="copy-suggested-response-to-clipboard-clicked"
              [disabled]="!responseBox.value || (review | checkReviewDeleted)"
            >
              <mat-icon class="copy-to-clip-board-icon">content_copy</mat-icon>
              {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.COPY_RESPONSE' | translate }}
            </button>
          </div>
          <div class="digital-agent-button-container">
            <ng-container *ngIf="(isRequestingApprovalLoading$$ | async) === false; else digitalAgentLoading">
              <button
                class="digital-agent-button request-approval-button"
                data-action="request-approval-clicked"
                mat-stroked-button
                (click)="handleRequestApproval(responseBox.value)"
                [ngClass]="{ 'secondary-button--text': responseBox.value }"
                [disabled]="(digitalAgentButtonDisabled$$ | async) || !responseBox.value"
              >
                {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.REQUEST_APPROVAL' | translate }}
              </button>
            </ng-container>
          </div>
          <div class="digital-agent-button-container">
            <ng-container
              *ngIf="
                (isPublishLoading$$ | async) === false && (canPublishDirectLoading$$ | async) === false;
                else digitalAgentLoading
              "
            >
              <button
                *ngIf="canPublishDirect$ | async; else useAnchorTag"
                class="digital-agent-button"
                data-action="post-response-clicked"
                mat-raised-button
                color="primary"
                [disabled]="digitalAgentButtonDisabled$$ | async"
                (click)="saveComment(responseBox.value)"
              >
                {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.POST_RESPONSE' | translate }}
              </button>
            </ng-container>
          </div>
          <ng-template #useAnchorTag>
            <a [href]="review.respondUrl" target="_blank">
              <button class="digital-agent-button" mat-raised-button color="primary">
                <mat-icon class="inline-icon-padding">open_in_new</mat-icon>
                <span>
                  {{ 'COMMON_REVIEW_CARD.COMMON.ACTION_LABELS.GO_TO_SOURCE' | translate }}
                </span>
              </button>
            </a>
          </ng-template>

          <ng-template #digitalAgentLoading>
            <mat-spinner [diameter]="24"></mat-spinner>
          </ng-template>
        </div>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #responding>
  <mat-spinner [diameter]="24"></mat-spinner>
</ng-template>
